var app = angular.module('leonardo');

var WorkOrderTypeFilter = function (WorkOrderService) {
  return function (type) {
    var name = 'Invalid type';
    angular.forEach(WorkOrderService.TYPE_OPTIONS, function(option) {
      if (type == option.id)
        name = option.name;
    });
    return name;
  };
};

app.filter('workOrderType', ['WorkOrderService', WorkOrderTypeFilter]);
